<template>
  <h1 class="title">
    Dashboard
  </h1>

  <div class="columns">
    <div class="column">
      <div class="box">
        <h2 class="subtitle">Balance Summary</h2>
        <balance-summary />
      </div>
    </div>
    <div class="column">
      <div class="box">
        <h2 class="subtitle is-flex">
          <span>Expenses by</span>
          <div class="select is-small ml-2">
            <select v-model="expenseBy">
              <option value="category">Category</option>
              <option value="subcategory">Subcategory</option>
              <option value="payment method">Payment Method</option>
              <option value="merchant type">Merchant Type</option>
            </select>
          </div>
        </h2>
        <expense-breakdown :by="expenseBy" />
      </div>
    </div>
  </div>

  <div class="columns">
    <div class="column">
      <div class="box">
        <h2 class="subtitle">Monthly Income</h2>
        <monthly-chart :items="incomeItems" :total-idx="1" color="#2ca02c" />
      </div>
    </div>
    <div class="column">
      <div class="box">
        <h2 class="subtitle">Monthly Expenses</h2>
        <monthly-chart :items="expenseItems" :total-idx="2" color="#d62728" />
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import BalanceSummary from './BalanceSummary.vue';
import ExpenseBreakdown from './ExpenseBreakdown.vue';
import MonthlyChart from './MonthlyChart.vue';

const { mapState } = createNamespacedHelpers('balanceSheet');

export default {
  components: {
    BalanceSummary,
    ExpenseBreakdown,
    MonthlyChart,
  },

  data() {
    return {
      expenseBy: 'category',
    };
  },

  computed: {
    ...mapState(['incomeItems', 'expenseItems']),
  },
};
</script>

<style scoped>
.box {
  height: 100%;
}
</style>
